module.exports = __webpack_public_path__ + "img/duration.a73ec31b.png";